import loadable from '@loadable/component';

const FinderIllustration = loadable(() => import('@assets/images/FinderIllustration.svg'));

export default FinderIllustration;
